import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { commonBaseUrl } from "network";

export const offerSlice = createApi({
    reducerPath: "offerSlice",
    baseQuery: fetchBaseQuery({
        baseUrl: commonBaseUrl,
        credentials: "include",
        prepareHeaders: (headers, { getState }) => {
            const state = getState();
            const token = state.auth?.token;
            if (token) {
                console.log('token', token);
                headers.set("authorization", `Bearer ${token}`);
            } else {
                console.warn("Token not found in state.auth");
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        getOffers: builder.query({
            query: ({ page = 1, limit = 10, search = "" }) => ({
                url: `/offer?page=${page}&limit=${limit}&search=${search}`,
                method: "GET",
            }),
            transformResponse: (response) => response,
        }),

        // ✅ Add New Location
        addOffers: builder.mutation({
            query: (body) => ({
                url: "/offer",
                method: "POST",
                body,
            }),
        }),

        // ✅ Update Existing Category
        updateOffer: builder.mutation({
            query: ( {id, body}) => ({
                url: `/offer/${id}`,
                method: "PUT",
                body,
            }),
        }),

        // ✅ Delete Category
        deleteOffer: builder.mutation({
            query: (id) => ({
                url: `/offer/${id}`,
                method: "DELETE",
            }),
        }),

        // 

        getTypeSubCat: builder.query({
            query: ({ selectedCategory = "" }) => ({
                url: `/category?type=${selectedCategory}`,
                method: "GET",
            }),
            transformResponse: (response) => response,
        }),

    }),
});

export const {
    useGetOffersQuery,
    useAddOffersMutation,
    useUpdateOfferMutation,
    useDeleteOfferMutation,
    useGetTypeSubCatQuery,
} = offerSlice;
